export var BadgeCategories;
(function (BadgeCategories) {
    BadgeCategories["default"] = "default";
    BadgeCategories["saving"] = "saving";
    BadgeCategories["writeOff"] = "writeOff";
    BadgeCategories["priceIndicatorLow"] = "priceIndicatorLow";
    BadgeCategories["priceIndicatorGreat"] = "priceIndicatorGreat";
    BadgeCategories["priceIndicatorGood"] = "priceIndicatorGood";
    BadgeCategories["priceIndicatorFair"] = "priceIndicatorFair";
    BadgeCategories["priceIndicatorHigh"] = "priceIndicatorHigh";
    BadgeCategories["custom"] = "custom";
    BadgeCategories["highlight"] = "highlight";
    BadgeCategories["tags"] = "tags";
    BadgeCategories["pdpSpecs"] = "pdpSpecs";
    BadgeCategories["onContent"] = "onContent";
})(BadgeCategories || (BadgeCategories = {}));
